<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col sm="4" md="3" lg="2" class="pa-0 d-none d-sm-block">
          <SideMenu/>
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right px-0 py-5 pl-sm-14 mt-10">
          <div class="dashboard py-0">
            <v-row justify="center">
              <v-col cols="12" sm="12" md="11" lg="10">
                <v-card
                  class="rounded-lg back-color pa-2 d-block d-md-flex align-center justify-space-between"
                  elevation="0"
                >
                  <v-col cols="10" sm="12" md="8" lg="8" class="py-0 px-2 ma-auto">
                    <v-card-title class="text-h4 text-center d-block text-center text-md-left pa-0">
                      <span class="ats-title blue--text text--light-blue text--darken-4 pr-1">¡Hola</span>
                      <span class="ats-title white--text">{{ `${getRole !== 'sysadmin' ? getUser.organization.name : getUser.firstName}!` }}</span>
                    </v-card-title>
                  </v-col>
                  <v-col cols="9" sm="8" md="4" lg="3" class="text-center pa-1 d-sm-block mx-auto my-0" v-if="getRole !== 'sysadmin'">
                    <v-btn block class="white--text" :to="{name: 'OfferPost', params: {followFlow: true}}" outlined >
                      NUEVA PUBLICACIÓN
                    </v-btn>
                  </v-col>

                  <!-- [sysadmin] -->
                  <v-col cols="12" sm="12" md="4" lg="3"  v-if="getRole === 'sysadmin'">
                    <v-text-field label="Buscar"
                      v-model="searchText"
                      @input="searchKeyInput()"
                      prepend-inner-icon="mdi-magnify"
                      color="info"
                      class="mb-0 pa-0 search-input"
                      hide-details="auto"
                      loader-height="5"
                      solo
                      clearable
                    >
                      <v-col cols="10" sm="12" md="8" lg="8" class="pa-1 ma-auto">
                        <v-card-title class="text-h4 text-center d-block text-center text-md-left pa-1">
                          <span class="ats-title blue--text text--light-blue text--darken-4 pr-1">¡Hola</span>
                          <span class="ats-title white--text">{{
                            `${
                              getRole !== "sysadmin"
                                ? getUser.organization.name
                                : getUser.firstName
                            }!`
                          }}</span>
                        </v-card-title>
                      </v-col>
                      <v-col cols="9" sm="8" md="4" lg="3" class="text-center pa-1 d-sm-block mx-auto my-0" v-if="getRole !== 'sysadmin'">
                        <v-btn
                          block
                          class="white--text"
                          :to="{name: 'OfferPost', params: {followFlow: true}}"
                          outlined
                        >
                          NUEVA PUBLICACIÓN
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="3" v-if="getRole === 'sysadmin'">
                        <v-text-field label="Buscar" v-model="searchText" prepend-inner-icon="mdi-magnify" color="info" class="mb-0 pa-0 search-input" hide-details="auto" :loading="loading" loader-height="5" solo clearable>
                        </v-text-field>
                      </v-col>
                    </v-text-field>
                  </v-col>
                </v-card>
                <v-row justify="center" class="py-4">
                  <v-col cols="12" sm="12" md="12" lg="12" class="pa-2">
                    <div class="txt-description">
                      <p class="px-5 py-4 ma-0">
                        Visualiza en esta pantalla un resumen de los procesos abiertos e ingresa a gestionar las postulaciones.
                        En CERRADAS quedará el registro de las publicaciones anteriores. Puedes poner la publicación en
                        ACTIVO o INACTIVO, las veces que quieras, para recibir postulantes o dejar de hacerlo. Cuando
                        ya encuentres al candidato no olvides CERRAR PROCESO lo que dará por finalizadas todas las gestiones.
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="11" lg="10">
                <!-- Tabs -->
                <v-tabs v-model="tab" grow>
                  <v-tabs-slider class="dashboard-tab__slider"></v-tabs-slider>
                  <v-tab class="dashboard-tab rounded-tl-lg" href="#open-offers" @click="changeTab('open')">
                    <div :class="`dashboard-tab__front${page.tab === 'open' ? '--active' : ''} rounded-t-lg`">
                      <span :class="`dashboard-tab__title${page.tab === 'open' ? '--active' : ''}`">ABIERTAS</span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            :class="`info-help info-help${tab === 'open-offers' ? '--blue' : '--white'}`"
                          >
                            mdi-information{{ tab === 'open-offers' ? '' : '-outline' }}
                          </v-icon>
                        </template>
                        <span class="tooltip-txt">Publicaciones con proceso de selección abierto.</span>
                      </v-tooltip>
                    </div>
                  </v-tab>
                  <v-tab class="dashboard-tab rounded-tr-lg" href="#close-offers" @click="changeTab('close')">
                    <span :class="`dashboard-tab__front${page.tab === 'close' ? '--active' : ''} rounded-t-lg`">
                      <span :class="`dashboard-tab__title${page.tab === 'close' ? '--active' : ''}`">CERRADAS</span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            :class="`info-help info-help${tab === 'close-offers' ? '--blue' : '--white'}`"
                          >
                            mdi-information{{ tab === 'close-offers' ? '' : '-outline' }}
                          </v-icon>
                        </template>
                        <span class="tooltip-txt">Publicaciones con proceso de selección cerrado.</span>
                      </v-tooltip>
                    </span>
                  </v-tab>
                </v-tabs>

                <!-- Tab Content -->
                <v-tabs-items touchless v-model="tab">
                  <!-- Open offers -->
                  <v-tab-item id="open-offers" value="tab">
                    <!-- Loader -->
                    <v-card
                      v-if="!page[page.tab].data.length"
                      class="dashboard-tab__loader d-flex justify-center align-center"
                      justify="center"
                    >
                      <div v-if="!loading">
                        <v-col class="text-center">
                          <v-icon color="white" size="70">{{`mdi-file`}}</v-icon>
                          <h2 v-if="getRole !== 'sysadmin'" class="my-5">Aún no tienes procesos abiertos</h2>
                          <h2 v-else class="my-5">{{emptyOffer}}</h2>
                        </v-col>
                      </div>
                      <div v-else class="text-center">
                        <v-progress-circular
                          :size="50"
                          color="white"
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card>

                    <OfferDetail
                      v-for="item in filteredPageOffers"
                      :key="item.id"
                      :offer="item"
                      :user="getUser"
                      @status="statusOffer"
                      @close="closeOffer"
                    />

                    <v-pagination
                      v-show="page.open.total >= 10"
                      v-model="page.open.index"
                      :length="pagesOpen"
                      @input="changePage"
                      :total-visible="8"
                    ></v-pagination>
                  </v-tab-item>

                  <!-- Closed offers -->
                  <v-tab-item id="close-offers" value="tab">
                    <!-- Loader -->
                    <v-card
                      v-if="!page[page.tab].data.length"
                      class="dashboard-tab__loader d-flex justify-center align-center"
                      justify="center"
                    >
                      <div v-if="!loading">
                        <v-col class="text-center">
                          <v-icon color="white" size="70">{{`mdi-file`}}</v-icon>
                          <h2 v-if="getRole !== 'sysadmin'" class="my-5">Aún no tienes procesos cerrados</h2>
                          <h2 v-else class="my-5">{{emptyOffer}}</h2>
                        </v-col>
                      </div>
                      <div v-else class="text-center">
                        <v-progress-circular
                          :size="50"
                          color="white"
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card>

                    <OfferDetail
                      v-for="item in page.close.data"
                      :key="item.id"
                      :offer="item"
                      :user="getUser"
                    />

                    <v-pagination
                      v-show="page.close.total >= 10"
                      v-model="page.close.index"
                      :length="pagesClose"
                      @input="changePage"
                      :total-visible="8"
                    ></v-pagination>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    
    <CloseOffer
        v-for="offerExpired in offersExpired" 
        :key="offerExpired && offerExpired.offer && offerExpired.offer.id ? offerExpired.offer.id: 0"
        :dialog="offerExpired.dialog" 
        :offer="offerExpired.offer" 
        @decline="nextDecline" 
        @closeOfferNow="closeOffer(offerExpired.offer)" 
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SideMenu from "@/components/SideMenu";
import CloseOffer from "@/components/CloseOffer";
import OfferDetail from "@/components/OfferDetail";
import { userComputed } from "@/store/helpers.js";
import { currentImg, datetime, handleTxt, meta } from "@/libs/mixins";

export default {
    name: "OrganizationDashboard",

    components: {
        SideMenu,
        OfferDetail,
        CloseOffer
    },

    mixins: [datetime, currentImg, handleTxt, meta],

    metaInfo() {
        return this.getUser.organization && this.getUser.organization.name ? this.getMetaInfo({
            title: `Publicaciones de ${ this.getUser.organization.name }`,
        }) : this.getMetaInfo({
            title: "Administrador de Sistema",
        });
    }, 

    data() {
        return {
            tab: "",
            state: {
                open: true,
                disable: false
            },
            page: {
                tab: "open",
                close: {
                    index: 1,
                    data: [],
                    total: 0
                },
                open: {
                    index: 1,
                    data: [],
                    total: 0
                }
            },
            offersExpired: [],
            expiredPosition: 0,
            emptyOffer: "Aún no tienes publicaciones para moderar",
            firstCreated: false,

            /// propiedades de busqueda de ofertas ///
            timerId: null,
            searchText: "",
            searchedText: "",
            loading: false,
            user: null,
            offerToClose: null
        };
    },
    watch: {
        async "page.open.data"() {
            if (this.page.open.data.length > 0 && this.firstCreated) {
                const expired = this.getRole !== "sysadmin" ? await this.expiredToClose() : [];
                if (expired.offersId && expired.offersId.length > 0) {
                    console.log(this.page.open.data);
                    expired.offersId.forEach(offerId => {
                        this.offersExpired.push({
                            offer: this.page.open.data.find(offer => offer.id === offerId),
                            dialog: false
                        });
                    });
                    this.offersExpired[this.expiredPosition].dialog = true;
                    this.firstCreated = false;
                }
            }
        }
    },
    created() {
        /// Carga inicial de ofertas ///
        this.firstCreated = true;
        this.reload(this.page.tab, 1);
    },

    computed: {
        ...userComputed,
        ...mapState("offers", ["deleted"]),
        pagesOpen() {
            return Math.ceil(this.page.open.total / parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE));
        },
        pagesClose() {
            return Math.ceil(this.page.close.total / parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE));
        },
        filteredPageOffers() {
            let deleted = this.deleted;
            
            return this.page.open.data.filter(offer => {
                return deleted.indexOf(offer.id) < 0;
            });
        },
    },

    methods: {
        ...mapActions("offers", ["expiredToClose"]),
        nextDecline() {
            this.offersExpired[this.expiredPosition].dialog = false; 
            if (this.expiredPosition === (this.offersExpired.length - 1)) {
                this.expiredPosition = 0;
            } else {
                this.expiredPosition = this.expiredPosition + 1;
                this.offersExpired[this.expiredPosition].dialog = true;
            }
        },
        searchKeyInput() {
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                this.searchOffer();
            }, process.env.VUE_APP_SEARCH_TIMEOUT);
        },
        searchOffer() {
            if (this.searchedText != this.searchText) {
                this.page.tab = "open";
                this.reload(this.page.tab, 1);
                this.searchedText = this.searchText;
            }
        },
        changePage(page) {
            if (this.getRole !== "sysadmin") this.offersExpired[0].offer = { id: 0 };
            this.reload(this.page.tab, page);
        },
        changeTab(tab) {
            this.page.tab = tab;
            this.reload(tab, this.page[tab].index);
        },
        reload(tab, page) {
            this.loading = true;
            this.page[this.page.tab].data = [];

            let parameters = {
                role: this.getUser.role,
                page: page
            };

            if (this.searchText) {
                parameters.tags = this.searchText.replace(/ /g, ",");
            }

            this.$store.dispatch("offers/" + tab, parameters).then((content) => {
                this.loading = false;
                this.page[this.page.tab].data = content.offers;
                this.page[this.page.tab].total = content.total;
                
            }).catch(() => {
                this.loading = false;
            });
        },
        goToOffer(offer) {
            this.$router.push({
                name: "OfferPost",
                params: { offerObs: offer, noStepper: true }
            });
        },
        getLogo(logo) {
            return process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + logo;
        },
        async closeOffer(offer) {
            const object = {
                offer: {
                    id: offer.id,
                    status: "close"
                }
            };
            if (this.getRole === "sysadmin") object.organizationId = offer.organization.id;
            await this.$store.dispatch("offers/update", object);
            await this.reload("open", this.page.open.index);
            
        },
        statusOffer(offer) {
            const saveOldStatus = offer.status;
            const object = {
                offer: {
                    id: offer.id,
                    status: offer.status === "open" ? "disable" : "open"
                }
            };
            if (this.getRole === "sysadmin") object.organizationId = offer.organization.id;
            offer.status = object.offer.status;
            this.$store
                .dispatch("offers/update", object)
                .then(() => {
                    console.warn("Status Saved: ", new Date().getTime());
                })
                .catch(err => {
                    console.error(err);
                    offer.status = saveOldStatus;
                });
        },
        normalize(text) {
            return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;
        }
    }
};
</script>

<style scoped>
.opacity {
    opacity: 0.6;
    background: #ffffff;
}
input.search-input label {
    top: 0;
}
</style>
